import React from "react";
import './Pricing.css';

const Pricing = () => {
    return (
        <section className="pricing">
            <div className="pricing-container">
                <h2 className="section-title">料金プラン</h2>
                <p className="section-subtitle">
                    明確で柔軟な料金体系
                </p>

                <div className="pricing-cards-wrapper">

                    {/* ── 左：0円お試しプラン ── */}
                    <div className="pricing-card pricing-card--trial">
                        <div className="pricing-badge pricing-badge--trial">
                            期間限定 無料
                        </div>

                        <div className="pricing-card-header">
                            <p className="pricing-plan-name">お試しプラン</p>
                            <div className="price-wrapper">
                                <div className="price-symbol">¥</div>
                                <div className="price-amount price-amount--trial">0</div>
                                <div className="price-period">円〜</div>
                            </div>
                            <p className="price-note">
                                初期設定まで完全無料でサポート
                            </p>
                        </div>

                        <div className="pricing-features">
                            <h3>サポート内容</h3>
                            <ul>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        広告アカウントの
                                        <wbr />初期設定を
                                        <wbr />完全サポート
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        無料打ち合わせ
                                        <wbr />2回
                                        <wbr />（各1時間まで）
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        広告専門用語集
                                        <wbr />資料を
                                        <wbr />プレゼント
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <button className="pricing-cta pricing-cta--trial" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                            無料で始める
                        </button>

                        <div className="pricing-disclaimer">
                            <p>
                                ※お試しプランは期間限定のご提供となります。<br />
                                ※無料期間終了後は通常プランへの
                                <wbr />移行もご相談いただけます。
                            </p>
                        </div>
                    </div>

                    {/* ── 右：通常プラン ── */}
                    <div className="pricing-card pricing-card--standard">
                        <div className="pricing-badge pricing-badge--standard">
                            おすすめ
                        </div>

                        <div className="pricing-card-header">
                            <p className="pricing-plan-name">通常プラン</p>
                            <div className="price-wrapper">
                                <div className="price-symbol">¥</div>
                                <div className="price-amount">55,000</div>
                                <div className="price-period">〜 / 月</div>
                            </div>
                            <p className="price-note">
                                初期費用0円・月額広告運用費のみ
                            </p>
                        </div>

                        <div className="pricing-features">
                            <h3>サポート内容</h3>
                            <ul>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        Google広告・Meta広告の
                                        <wbr />月次運用管理
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        キーワード戦略・
                                        <wbr />ターゲット設計
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        A/Bテスト・
                                        <wbr />入札最適化
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        月次レポート・
                                        <wbr />改善提案
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        定期ミーティング
                                        <wbr />（月1回）
                                    </span>
                                </li>
                                <li>
                                    <span className="feature-check">✓</span>
                                    <span>
                                        LP改善提案・
                                        <wbr />CVR向上サポート
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <button className="pricing-cta pricing-cta--standard" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                            無料相談を申し込む
                        </button>

                        <div className="pricing-disclaimer">
                            <p>
                                ※広告費は別途必要となります。<br />
                                ※ご要望に応じて
                                <wbr />カスタムプランの
                                <wbr />ご提案も可能です。
                            </p>
                        </div>
                    </div>

                </div>{/* /.pricing-cards-wrapper */}
            </div>
        </section>
    );
};

export default Pricing;